
<v-dialog :value="value" @input="onDialogInput" :persistent="editingSaving"
          :content-class="showConfirmation ? 'postAddDialog' : 'configuratorDialog'"
          :fullscreen="!showConfirmation && $vuetify.breakpoint.xsOnly" scrollable>
  <AddedToBasketDialog v-if="showConfirmation" :product="configuredProduct" :items="addedItems" :upgraded="upgraded"
                       @configureAgain="configureAgain" @configureProduct="configureProduct"
                       @backToProducts="backToProducts"/>
  <div v-show="!showConfirmation" ref="configuratorFrame" class="configuratorFrame">
    <DiscountBanner v-if="!mobile && hasCoupons" class="desktopConfiguratorDiscount" height-adaptive/>
    <v-card class="configuratorShell">
      <div v-if="mobile && hasCoupons" class="configuratorHeader">
        <DiscountBanner compact class="configuratorDiscount" height-adaptive/>
      </div>
      <div class="configuratorCloseRow" :class="{'is-upgrading': replacementSteps.length > 0}">
        <h2 v-if="replacementSteps.length" class="upsell-configuration-title" :aria-label="upsellConfigurationTitle">
          <span v-for="(part, index) in upsellConfigurationTitleParts" :key="index" class="upsell-title-part">{{ part }}</span>
          <span v-if="replacementSteps.length > 1" class="upsell-title-progress">({{ replacementProgress }})</span>
        </h2>
        <v-btn icon class="closeDialog" :disabled="editingSaving" :aria-label="$vuetify.lang.t('$vuetify.close')"
               @click="onDialogInput(false)"><v-icon>close</v-icon></v-btn>
      </div>
      <v-alert v-if="editingError" type="error" dense class="ma-3">{{ editingError }}</v-alert>
      <div class="configuratorContent">
        <ProductConfigurator v-if="value" :key="`${configuredProduct.id}-${configurationVersion}`" :product="configuredProduct"
                             :prefill="configurationPrefill"
                             @backToProducts="backToProducts"
                             @addedToBasket="onAddedToBasket" @error="onConfiguratorError"/>
      </div>
    </v-card>
  </div>
</v-dialog>
